export default "__VITE_ASSET__Bdrp2cBw__"